<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  fields: {
    type: Array,
    default: () => [],
  },
  totalCustomers: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();

const items = computed(() => {
  return props.fields.map(field => ({
    id: field.id,
    displayName: field.displayName || field.fieldName,
    value: field.collectedCustomers || 0,
    completionRate: Math.round((field.completionRate || 0) * 100),
  }));
});
</script>

<template>
  <div class="rounded-2xl border border-n-weak bg-white/80 p-4 shadow-sm dark:border-white/10 dark:bg-slate-900/30">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-base font-semibold text-n-slate-12 dark:text-white">
          {{ $t('DATA_COLLECTION_REPORTS.COVERAGE.TITLE') }}
        </h3>
        <p class="text-sm text-n-gray-6 dark:text-n-gray-4">
          {{ t('DATA_COLLECTION_REPORTS.COVERAGE.SUBTITLE', { total: totalCustomers }) }}
        </p>
      </div>
    </div>
    <div class="mt-4 space-y-4">
      <div v-if="!items.length" class="text-sm text-n-gray-5 dark:text-n-gray-3">
        {{ $t('DATA_COLLECTION_REPORTS.COVERAGE.EMPTY') }}
      </div>
      <div v-for="item in items" v-else :key="item.id" class="space-y-2">
        <div class="flex items-center justify-between text-sm">
          <span class="font-medium text-n-slate-12 dark:text-white">
            {{ item.displayName }}
          </span>
          <span class="text-n-gray-6 dark:text-n-gray-3">
            {{ item.value }} • {{ item.completionRate }}%
          </span>
        </div>
        <div class="h-2 rounded-full bg-n-gray-2 dark:bg-n-gray-7">
          <div
            class="h-2 rounded-full bg-primary-500 transition-all"
            :style="{ width: `${item.completionRate}%` }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
